import { useSelector } from 'react-redux';

import { selectBulkOfProduct } from '@/domains/productDiscovery/ProductPage/common/modules/BulkPurchase/ducks/BulkPurchase.selectors';
import type {
  UseBulkPurchaseReturn,
  WithPrice,
} from '@/domains/productDiscovery/ProductPage/common/modules/BulkPurchase/hooks/types';
import { SpartacuxProductDiscoveryDomainState } from '@/productDiscovery/productDiscovery.model';
import { Threshold } from '@/productDiscovery/ProductPage/common/modules/BulkPurchase/interfaces/BulkPurchase.model';
import { getBulkPurchaseThresholdIndex } from '@/productDiscovery/ProductPage/common/modules/BulkPurchase/utils/getBulkPurchaseThresholdIndex';

export function useBulkPurchase(
  productId: number,
  quantity: number,
  unitPrice: number,
): UseBulkPurchaseReturn | undefined {
  const bulkPurchaseData = useSelector(
    (state: SpartacuxProductDiscoveryDomainState) =>
      selectBulkOfProduct(state, productId),
  );

  if (!bulkPurchaseData) {
    return undefined;
  }

  const selectedThresholdIndex = getBulkPurchaseThresholdIndex(
    bulkPurchaseData.thresholds,
    quantity,
  );

  const thresholds = bulkPurchaseData.thresholds.map(
    (threshold: Threshold): WithPrice<Threshold> => ({
      ...threshold,
      price: unitPrice * (1 - threshold.percent / 100),
    }),
  );

  return {
    selectedThresholdIndex,
    thresholds,
  };
}
